import {Banner} from '@primer/react'
import {useEffect} from 'react'
import {announce} from '@github-ui/aria-live'

import {
  useBatchComposition,
  useIsFixWithCopilotAvailable,
  useIsPullRequestFromFork,
} from '../../../stores/layout-selectors'

const DISALLOWED_TAB_TITLE = 'Batch actions unavailable'
const ACCOUNT_REASON = 'Fix with Copilot isn’t available on your account'
const FORK_REASON = 'Fix with Copilot isn’t available on pull requests from a fork'
const NO_SUGGESTION_PREFIX = 'This batch doesn’t contain any suggestions to commit'
const MIXED_PREFIX = 'This batch contains items other than committable suggestions, so it can’t be committed'
const PUBLISH_HINT = 'You can still publish your review from the review menu.'

export function ManageBatchDisallowedTabBanner() {
  const batchComposition = useBatchComposition()
  const isFixWithCopilotAvailable = useIsFixWithCopilotAvailable()
  const isFromFork = useIsPullRequestFromFork()

  const prefix =
    batchComposition === 'no-suggestion'
      ? NO_SUGGESTION_PREFIX
      : batchComposition === 'mixed'
        ? MIXED_PREFIX
        : undefined
  const message = prefix ? `${prefix}, and ${isFromFork ? FORK_REASON : ACCOUNT_REASON}. ${PUBLISH_HINT}` : undefined
  const shouldShowWarning = !isFixWithCopilotAvailable && message !== undefined

  useEffect(() => {
    if (shouldShowWarning && message) {
      announce(message)
    }
  }, [shouldShowWarning, message])

  if (!shouldShowWarning || !message) {
    return null
  }

  return <Banner className="mb-3" variant="warning" title={DISALLOWED_TAB_TITLE} hideTitle description={message} />
}
